import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
const benefits = ['Deja de buscar recetas en Pinterest y ten una cena deliciosa lista con facilidad.', 'Deja de estresarte por cocinar cada día—solo saca un paquete del congelador y actívalo.', 'Deja de pelear con tus hijos a la hora de cenar y realmente siéntate a disfrutar tiempo con ellos.', 'Deja de planificar comidas cada semana; todo está incluido en este Protocolo.', '¡Deja de gastar dinero en comida a domicilio y dale a tu familia verdaderas comidas caseras!'];
export const SolutionBenefits = () => {
  return <section className="bg-gray-50 px-4 py-8 md:py-16 lg:px-8" data-id="element-228">
      <div className="mx-auto max-w-4xl" data-id="element-229">
        <div className="rounded-3xl bg-white p-8 shadow-xl md:p-12" data-id="element-230">
          <ul className="space-y-6" data-id="element-231">
            {benefits.map((benefit, index) => <motion.li key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} className="flex items-start space-x-4" data-id="element-232">
                <CheckCircle2 className="mt-1 h-6 w-6 flex-shrink-0 text-terracotta" data-id="element-233" />
                <span className="text-lg font-medium text-text-dark md:text-xl" data-id="element-234">
                  {benefit}
                </span>
              </motion.li>)}
          </ul>

          <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.6
        }} className="mt-10 border-t border-gray-100 pt-8 text-center" data-id="element-235">
            <p className="font-serif text-2xl italic text-terracotta md:text-3xl" data-id="element-236">
              Mereces disfrutar tus noches sin el peso de no saber qué vas a
              darle de comer a tu familia.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
};